import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import './UserAdmin.scss';

const UserAdmin = ({ onBack }) => {
  const [searchEmail, setSearchEmail] = useState('');
  const [foundUser, setFoundUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newUser, setNewUser] = useState({
    email: '',
    firstName: '',
    lastName: '',
    vendorId: '',
    companyName: ''
  });

  const callAPI = async (payload) => {
    const user = await Auth.currentAuthenticatedUser();
    const token = user.signInUserSession.idToken.jwtToken;
    
    // Use environment-based API endpoint or fallback to relative path
    const apiEndpoint = process.env.REACT_APP_USER_MANAGEMENT_API_URL || '/api/user-management';
    
    const response = await fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    
    if (!response.ok) {
      throw new Error(`API call failed: ${response.status} ${response.statusText}`);
    }
    
    return response.json();
  };

  const searchUser = async () => {
    if (!searchEmail) return;
    
    setLoading(true);
    try {
      const result = await callAPI({ action: 'get', username: searchEmail });
      setFoundUser(result.user || null);
    } catch (error) {
      console.error('Error searching user:', error);
      setFoundUser(null);
    }
    setLoading(false);
  };

  const deleteUser = async (username) => {
    if (!window.confirm(`Delete user ${username}?`)) return;
    
    try {
      await callAPI({ action: 'delete', username });
      setFoundUser(null);
      setSearchEmail('');
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  const createUser = async (e) => {
    e.preventDefault();
    try {
      await callAPI({
        action: 'create',
        username: newUser.email,
        email: newUser.email,
        temp_password: 'TempPass123!',
        user_attributes: [
          { Name: 'email', Value: newUser.email },
          { Name: 'name', Value: `${newUser.firstName} ${newUser.lastName} (EXT Vendor)` },
          { Name: 'family_name', Value: newUser.lastName },
          { Name: 'given_name', Value: newUser.firstName },
          { Name: 'custom:vendorId', Value: newUser.vendorId },
          { Name: 'custom:companyName', Value: newUser.companyName },
          { Name: 'email_verified', Value: 'true' }
        ]
      });
      setNewUser({ email: '', firstName: '', lastName: '', vendorId: '', companyName: '' });
      setShowCreateForm(false);
    } catch (error) {
      console.error('Error creating user:', error);
    }
  };



  return (
    <div className="user-admin">
      <div className="admin-header">
        <button onClick={onBack} className="back-button">← Back</button>
        <h2>User Management</h2>
        <button onClick={() => setShowCreateForm(true)} className="create-button">+ Add User</button>
      </div>

      <div className="search-section">
        <h3>Search User</h3>
        <div className="search-form">
          <input
            type="email"
            placeholder="Enter user email"
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
          />
          <button onClick={searchUser} disabled={!searchEmail || loading}>
            {loading ? 'Searching...' : 'Search'}
          </button>
        </div>
      </div>

      {foundUser && (
        <div className="user-details">
          <h3>User Details</h3>
          <div className="user-card">
            <p><strong>Email:</strong> {foundUser.email}</p>
            <p><strong>Name:</strong> {foundUser.name}</p>
            <p><strong>Company:</strong> {foundUser.companyName}</p>
            <p><strong>Vendor ID:</strong> {foundUser.vendorId}</p>
            <button 
              onClick={() => deleteUser(foundUser.username)} 
              className="delete-button"
            >
              Delete User
            </button>
          </div>
        </div>
      )}

      {showCreateForm && (
        <div className="create-form">
          <h3>Create New User</h3>
          <form onSubmit={createUser}>
            <input
              type="email"
              placeholder="Email"
              value={newUser.email}
              onChange={(e) => setNewUser({...newUser, email: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="First Name"
              value={newUser.firstName}
              onChange={(e) => setNewUser({...newUser, firstName: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="Last Name"
              value={newUser.lastName}
              onChange={(e) => setNewUser({...newUser, lastName: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="Vendor ID"
              value={newUser.vendorId}
              onChange={(e) => setNewUser({...newUser, vendorId: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="Company Name"
              value={newUser.companyName}
              onChange={(e) => setNewUser({...newUser, companyName: e.target.value})}
              required
            />
            <div className="form-buttons">
              <button type="submit">Create User</button>
              <button type="button" onClick={() => setShowCreateForm(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default UserAdmin;